import { loadTranslations } from 'react-redux-i18n'
import { store } from '../../../../app/store'

store.dispatch(
  loadTranslations({
    en: {
      ...store.getState().i18n.translations.en,
      common: {
        ...store.getState().i18n.translations.en.common,
        order: {
          ...store.getState().i18n.translations.en.common.order,
          businessCreditReport: {
            AVAILABLE: 'Latest Available FS Data',
            UNAVAILABLE: 'Unavailable',
            DELIVERY_TIME: 'Expected delivery time',
            ON_REQUEST_VERSION: 'On Request Version',
            READY_TO_USE_VERSION: 'Ready-to-use Version',
            SAMPLE_REPORT: 'Sample report',
            CHECK_DATA_AVAILABILITY: 'Check data availability',
            DATE_CREATED: 'Date Created',
            REPORTING_YEAR: 'Reporting Year',
            DAYS: 'days',
          },
        },
      },
    },
    vi: {
      ...store.getState().i18n.translations.vi,
      common: {
        ...store.getState().i18n.translations.vi.common,
        order: {
          ...store.getState().i18n.translations.vi.common.order,
          businessCreditReport: {
            AVAILABLE: 'Dữ Liệu BCTC Sẵn Có Gần Nhất',
            UNAVAILABLE: 'Không có sẵn',
            DELIVERY_TIME: 'Thời gian trả báo cáo dự kiến',
            ON_REQUEST_VERSION: 'Phiên Bản Mới',
            READY_TO_USE_VERSION: 'Phiên Bản Sẵn Có',
            SAMPLE_REPORT: 'Báo cáo mẫu',
            CHECK_DATA_AVAILABILITY: 'Kiểm tra tính sẵn có của dữ liệu',
            DATE_CREATED: 'Ngày Tạo',
            REPORTING_YEAR: 'Năm Báo Cáo',
            DAYS: 'ngày',
          },
        },
      },
    },
  }),
)
